// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3EcgN","title":"FrontImage_title__kbXSl"};